import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { AccessTime } from "@mui/icons-material";
import { formatIntervalLabel } from "../../../helpers/flowIntervalLabel";

const IntervalNode = memo(({ id, data, isConnectable, selected }) => {
  const label = formatIntervalLabel(data?.sec);

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<AccessTime />}
      title="Intervalo"
      color="#F7953B"
      bgColor="#FFFBFA"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          background: "#FFF3E0",
          border: "1px solid #FFE0B2",
          borderRadius: 16,
          padding: "4px 12px",
          marginTop: 2,
        }}
      >
        <AccessTime style={{ fontSize: 14, color: "#F7953B" }} />
        <span
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: "#E65100",
          }}
        >
          {label}
        </span>
      </div>
    </NodeWrapper>
  );
});

IntervalNode.displayName = "IntervalNode";
export default IntervalNode;
